import { render, staticRenderFns } from "./ManageSuggestion.vue?vue&type=template&id=5dc653b9&scoped=true"
import script from "./ManageSuggestion.vue?vue&type=script&lang=js"
export * from "./ManageSuggestion.vue?vue&type=script&lang=js"
import style0 from "./ManageSuggestion.vue?vue&type=style&index=0&id=5dc653b9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc653b9",
  null
  
)

export default component.exports